module.exports = __webpack_public_path__ + "assets/img/b796d8992a4a6e59f75df35c7b7cb2d0.svg";